import {dd,store,app} from 'systems/imports'
import Vue from 'vue'

//Vueディレクティブ

//ポップアップを関連つける
Vue.directive('bs-popover', {
  bind(el, binding, vnode) {
    // Hack function
    const getAttr = (el, child) => {
      return $(`.data-${child}`, el).html();
    };
    // Dinamic Popover
    $(el).popover({
      html: true,
      placement: 'bottom',
      title: function () {
        return getAttr(binding.value.bindSelector, 'title');
      },
      content: function () {
        return getAttr(binding.value.bindSelector, 'content');
      }
    });
  },
  update(){
    //console.log("update")
  }
})



// WEBPACK FOOTER //
// ./src/systems/directives.js